import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { getGroupStatusProperty, HHNTheme } from "hhn-commons";
import { shouldForwardProp } from "../../../common/Common.style";

type StatusBarProp = {
  status: number;
};

export const UpperBar = styled(Box, {
  shouldForwardProp: prop => shouldForwardProp<StatusBarProp>(["status"], prop),
})<StatusBarProp>(({ status }) => ({
  height: "25px",
  width: "4px",
  backgroundColor: getGroupStatusProperty(status).upperBarColor,
}));

export const LowerBar = styled(Box, {
  shouldForwardProp: prop => shouldForwardProp<StatusBarProp>(["status"], prop),
})<StatusBarProp>(({ status }) => ({
  height: "25px",
  width: "4px",
  backgroundColor: getGroupStatusProperty(status).lowerBarColor,
}));

export const ServicesToPatientStyle = styled.li`
  display: inline-block;
  width: auto;
  margin-right: 5px;
`;

export const PatientStatusBarContainer = styled(Box)`
  flex-direction: column;
`;

export const StatusImgOutline = styled(Box)`
  height: 50px;
  width: 50px;
  background-color: ${HHNTheme.surfaceVariant};
  border-radius: 50%;
`;

export const PatientDetailText = styled(Typography)`
  margin-left: 4px;
  max-width: 190px;
  font-size: 12px;
  font-weight: 400;
  text-overflow: ellipsis;
  white-space: noWrap;
  overflow: hidden;
`;

export const ChatListItemAbout = styled(Typography)`
  margin-bottom: 3px;
  font-size: 12px;
`;

export const ServicesToPatientList = styled.ul`
  padding: 0;
  margin: 0 0 4px;
`;
